import { Avatar, Button, CardContent, Typography } from '@material-ui/core'
import cx from 'clsx'
import { ComponentProps, ElementType, MouseEventHandler } from 'react'

import { Emphasize } from './Emphasize'

interface QAContentProps {
  question?: string
  onClick?: MouseEventHandler
  info?: boolean
  className?: string
  LinkComponent?: ElementType
}
export function QAContent({ question, onClick, info, className, LinkComponent }: QAContentProps) {
  const buttonProps: ComponentProps<typeof Button> & {
    component?: ElementType
  } = {}
  if (onClick) {
    buttonProps.onClick = onClick
  }
  if (LinkComponent) {
    buttonProps.component = LinkComponent
  }
  return (
    <CardContent className={cx('faq-panel-content', className)}>
      <Button
        color="inherit"
        fullWidth
        className={cx('faq-panel-content-button', 'faq-panel-content__button')}
        {...buttonProps}
      >
        <Avatar className="faq-panel-content__avatar">{info ? '!' : 'Q'}</Avatar>
        <Typography className="faq-panel-content__q" variant="h5">
          <Emphasize target={question || ''} />
        </Typography>
      </Button>
    </CardContent>
  )
}
